import { useToast } from '#providers/ToastProvider';
import { RepetitionType } from '#types/schedule';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router';
import { patch } from '../libs';
import queryKeys from '../queryKeys';

interface Payload {
  taughtAt: string;
  endedAt: string;
  round: number | null;
  totalRound: number | null;
  repetition: RepetitionType | null;
}

interface Params {
  id: string;
}

/**
 * 코치 - 직접 일정 수정 (수업 일시만 수정 가능함)
 */
export function usePatchScheduleCoachMutation() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  const naviate = useNavigate();

  return useMutation(
    ({ id, ...payload }: Params & Payload) =>
      patch(`/schedules/coach/${id}`, payload),
    {
      onSuccess: id => {
        showToast({
          type: 'success',
          message: '일정이 수정되었습니다.'
        });
        queryClient.invalidateQueries([queryKeys.SCHEDULE, id]);
        naviate(-1);
      },
      onError: (error: AxiosError<{ message: string }>) => {
        showToast({
          type: 'fail',
          message:
            error && error.response
              ? error?.response.data?.message
              : '일정 수정에 실패했습니다.'
        });
      }
    }
  );
}
